export default {"src":"/_next/static/media/nara-detective.e11d16bd.svg","height":320,"width":320,"blurWidth":0,"blurHeight":0};